module.exports = __webpack_public_path__ + "img/suggestion.98af1820.png";